import { ALO_API_HOST } from '../../../../utils/constants';
import { IStoreAvailabilityData, StoreLocatorResponseError } from '../StoreLocator/storeLocatorTypes';
import { customerLocationState } from '../StoreLocator/customerLocationState';

export const FIND_IN_STORE_LAT_LONG = 'find_in_store_lat_long';
export const FIND_IN_STORE_POSTAL_CODE = 'find_in_store_postal_code';

export const checkStoreAvailability = async (input: StoreAvailabilityInput) => {
  const { sku, limit } = input;
  if (!customerLocationState.coordinates) return { detail: 'Location is unknown' }; // Location is unknown

  const queryParams = new URLSearchParams({
    sku,
    latitude: customerLocationState.coordinates.latitude,
    longitude: customerLocationState.coordinates.longitude,
    ...(limit ? { limit: limit.toString() } : {}),
  });

  const response = await fetch(`${ALO_API_HOST}/v1/store_availability?${queryParams.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    console.error(`HTTP error! status: ${response.status}`);
    return { detail: response.status.toString() };
  }

  const data: IStoreAvailabilityData[] | StoreLocatorResponseError = await response.json();
  return data;
};

// we are receiving country code 'GB' when United Kingdom is selected from currency/shipping dropdown but need to send 'UK' to API
export function mapCountryCode(countryCode: string) {
  const countryMappings: Record<string, string> = {
    GB: 'UK',
  };
  // check if the provided code is in the mapping, otherwise return the original code
  return countryMappings[countryCode] || countryCode;
}

export interface StoreAvailabilityInput {
  sku: string;
  limit?: number;
}

export interface IFindInStoreState {
  enabled: boolean;
  storesData: IStoreAvailabilityData[] | null;
  storesDataError: StoreLocatorResponseError | null;
  fetchStoresData: (sku: string) => Promise<void>;
}
